import { render } from "./wFilter.vue?vue&type=template&id=6e8a5a14&scoped=true"
import script from "./wFilter.vue?vue&type=script&lang=js"
export * from "./wFilter.vue?vue&type=script&lang=js"

import "./wFilter.vue?vue&type=style&index=0&id=6e8a5a14&lang=scss&scoped=true"

import exportComponent from "D:\\A-wy-work\\wy-vue-source\\wy-saas\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e8a5a14"]])

export default __exports__